import { Drawer, DrawerContent, Icon } from '@repo/ui';
import { useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';

import { getTermURL } from '@/components/tax-refund/common/utils/getTermURL';

type BaseProps = {
  isOpen: boolean;
  handleClose: () => void;
};

type UrlCase = BaseProps & {
  url: string;
  termKey?: never;
  fragmentRef?: never;
};

type ApiCase = BaseProps & {
  url?: never;
  termKey: string;
  fragmentRef: unknown;
};

type Props = UrlCase | ApiCase;

export function TermDrawer({ isOpen, handleClose, url, termKey, fragmentRef }: Props) {
  const data = useFragment(
    graphql`
      fragment TermDrawer on Query @argumentDefinitions(corpType: { type: "CorpTypeEnum!" }, termsType: { type: "RefundTermsType!" }) {
        ...getTermURL @arguments(corpType: $corpType, termsType: $termsType)
      }
    `,
    (fragmentRef || null) as any
  );

  const src = useMemo(() => {
    if (url) return url;
    if (data && termKey) return getTermURL(data, termKey);
    return '';
  }, [url, data, termKey]);

  return (
    <Drawer open={isOpen}>
      <DrawerContent isFullScreen outSideClickAction={handleClose}>
        <div className="flex h-12 items-center justify-end bg-white">
          <div className="flex h-10 w-10 items-center justify-center cursor-pointer" onClick={handleClose}>
            <Icon type="close" size={24} />
          </div>
        </div>
        {src && <iframe className="h-full w-full" allowFullScreen src={src} title="약관 내용" />}
      </DrawerContent>
    </Drawer>
  );
}
